import { createFileRoute } from "@tanstack/react-router";
import DashboardSettings from "@/pages/dashboard/Settings";
import ProtectedRoute from "@/components/ProtectedRoute";

export const Route = createFileRoute("/dashboard/settings")({
  component: () => (
    <ProtectedRoute>
      <DashboardSettings />
    </ProtectedRoute>
  ),
});
